<section class="hero">
    <h1>
        Nossos <span class="green">Embaixadores</span>
    </h1>
    <p>O Dia de Doar conta com porta-vozes que nos ajudam a ampliar o reconhecimento do movimento. São especialistas em
        ESG,
        empreendedores e empreendedoras sociais e ativistas pela Cultura de Doação. </p>
    <img src="assets/hero/ambassador-hero.png" alt="picture">
</section>